import React from "react";
import { Paperclip } from "lucide-react";
import { INK, BURGUNDY, LINE } from "../../Bureau/bureauTokens";

function formatTime(date) {
  const d = new Date(date);
  return isNaN(d) ? "" : d.toLocaleTimeString("fr-FR", { hour: "2-digit", minute: "2-digit" });
}

function formatFileSize(bytes) {
  if (!bytes) return "";
  if (bytes < 1024 * 1024) return `${Math.round(bytes / 1024)} Ko`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} Mo`;
}

function MessageBubble({
  body,
  createdAt,
  outgoing,
  attachmentUrl,
  attachmentName,
  attachmentType,
  attachmentSize,
}) {
  const isImage = attachmentType?.startsWith("image/");

  return (
    <div className={`flex ${outgoing ? "justify-end" : "justify-start"}`}>
      <div
        className="max-w-[70%] px-3.5 py-2.5 text-[12.5px] leading-relaxed whitespace-pre-wrap"
        style={{
          background: outgoing ? BURGUNDY : "#fff",
          color: outgoing ? "#fff" : INK,
          border: outgoing ? "none" : `1px solid ${LINE}`,
          borderRadius: outgoing ? "14px 14px 4px 14px" : "14px 14px 14px 4px",
        }}
      >
        {attachmentUrl && (
          isImage ? (
            <a href={attachmentUrl} target="_blank" rel="noopener noreferrer" className="block mb-1.5">
              <img
                src={attachmentUrl}
                alt={attachmentName || "Image"}
                className="rounded-lg max-w-full block"
                style={{ maxHeight: 220 }}
              />
            </a>
          ) : (
            <a
              href={attachmentUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 mb-1.5 px-2.5 py-2 rounded-lg"
              style={{ background: outgoing ? "rgba(255,255,255,.15)" : "#f8fafc" }}
            >
              <Paperclip size={13} className="flex-shrink-0" />
              <span className="min-w-0">
                <span className="block text-[11.5px] font-medium truncate" style={{ maxWidth: 180 }}>
                  {attachmentName}
                </span>
                {attachmentSize && (
                  <span className="block text-[10px]" style={{ opacity: 0.75 }}>
                    {formatFileSize(attachmentSize)}
                  </span>
                )}
              </span>
            </a>
          )
        )}
        {body}
        <div
          className="text-[10px] mt-1 text-right"
          style={{ color: outgoing ? "rgba(255,255,255,.75)" : undefined, opacity: outgoing ? 1 : 0.55 }}
        >
          {formatTime(createdAt)}
        </div>
      </div>
    </div>
  );
}

export default MessageBubble;
